import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import SampleCode, { Container } from '.'
import rehypeReact from 'rehype-react'
import styles from './styles.module.css'

export const PureContent = ({ data, src, sticky }) => {
  const renderAst = new rehypeReact({
    createElement: React.createElement,
    components: {
      'sample-code': SampleCode,
      'sample-code-container': Container,
      'sample-code-loader': Loader
    },
  }).Compiler

  const { allFile } = data
  const result = allFile.edges.filter(edge => edge.node.name === src) 
  if (result.length === 0) {
    throw new Error(`no code found with name ${src}`)
  }

  if(result.length > 1) {
    throw new Error(`there is more than one code file with name ${src}`)
  }

  const { node } = result[0]
  return (
    <div className={sticky && styles.sticky}>
      {renderAst(node.childMarkdownRemark.htmlAst)}
    </div>
  )
}

const Loader = ({ src, sticky = true }) => {
  const getSrcContent = () => (
      <StaticQuery
        query={graphql`
        query MyQuery {
          allFile(filter: {ext: {eq: ".md"}, absolutePath: {regex: "/\\/code_examples\\//"}}) {
            edges {
              node {
                name
                absolutePath
                childMarkdownRemark {
                  htmlAst
                }
              }
            }
          }
        }
        `}
        render={data => <PureContent data={data} src={src} sticky={sticky} />}
      />
    )

  return getSrcContent()
}

export default Loader